import { useGetTemplateOnboardingViewedTime } from './useTemplateOnboardingViewedTime.ts';

export const useShouldHideFeatureForWacTemplateUsers = ():
	| {
			isLoading: boolean;
			shouldHideFeatureForWacTemplateUsers: undefined;
	  }
	| {
			isLoading: false;
			shouldHideFeatureForWacTemplateUsers: boolean;
	  } => {
	const { templateOnboardingViewedTime, isLoading } = useGetTemplateOnboardingViewedTime();
	if (isLoading) {
		return { isLoading: true, shouldHideFeatureForWacTemplateUsers: undefined };
	}
	const msSinceOnboardingViewed = Date.now() - templateOnboardingViewedTime;
	const daysSinceOnboardingViewed = Math.floor(msSinceOnboardingViewed / (1000 * 60 * 60 * 24));
	return {
		isLoading,
		shouldHideFeatureForWacTemplateUsers: daysSinceOnboardingViewed === 0,
	};
};
